import { ReactElement } from 'react'

import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'
import ComprovantesExtrato from 'modules/pagamentos/pages/components/ComprovantesExtrato'
import ComprovantesExtratoImpl from 'modules/pagamentos/domain/usecases/ComprovantesExtrato'
import BaixarComprovanteImpl from 'modules/pagamentos/domain/usecases/BaixarComprovante'

export const ComprovantesExtratoFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const comprovantesExtrato = new ComprovantesExtratoImpl(pagamentoRepository)
  const baixarComprovante = new BaixarComprovanteImpl(pagamentoRepository)
  return (
    <ComprovantesExtrato
      comprovantesExtrato={comprovantesExtrato}
      baixarComprovante={baixarComprovante}
    />
  )
}
